<rask-takt-chart-legend class="w-100"></rask-takt-chart-legend>
@if (data && height) {
  <div style="display: block;">
    <canvas #canvas height="{{height}}"></canvas>
  </div>
}
